import Filter from 'bad-words';
import { badWordsShort } from './badWords';

const placeholders = [ "🙊", "🙈", "🙉", "🐷", "🐙", "💩", "🐣"]
const rand = placeholders[Math.floor(Math.random() * placeholders.length)];

export const filter = new Filter({
  placeHolder: rand,
  list: badWordsShort
});
